// extracted by mini-css-extract-plugin
export default {"appWrapper":"App_appWrapper__p-V5m","app":"App_app__zr1wm","page":"App_page__5vKaD","open":"App_open__lgJmw"};